module.exports = __webpack_public_path__ + "static/media/talwar_clinic.17609447.png";